module.exports = __webpack_public_path__ + "static/media/logo_2x.ae14ac5a.png";